import { FC, useEffect, useState } from "react";

import { LineChart } from "../../../Charts/LineChart/LineChart";
import { useBreakpoint } from "../../../../hooks/useBreakpoint";
import { formatNumber } from "../../../../utils/formatNumber";

import { EuropeanMarketHistoricalPictureProps } from "./EuropeanMarketHistoricalPicture.type";
import { EUROPEAN_MARKET_HISTORICAL_PICTURE_CHART_DATA_KEYS } from "./EuropeanMarketHistoricalPicture.const";

const EuropeanMarketHistoricalPicture: FC<EuropeanMarketHistoricalPictureProps> = ({ data }) => {
	const chartSize = useBreakpoint();

	const [dotLabelFontSize, setDotLabelFontSize] = useState<number>(12);

	const [chartData, setChartData] = useState(
		data.map((value) => {
			return { time: value.time, units: value.units };
		}),
	);
	const [axisFontSize, setAxisFontSize] = useState(12);
	const [marginLeft, setMarginLeft] = useState(0);
	const [xAxisPadding, setXAxisPadding] = useState(50);
	const [chartHeight, setChartHeight] = useState(450);

	useEffect(() => {
		switch (chartSize) {
			case "xs":
				setChartData(data.filter((dataEntry) => ["2017", "2019", "2021", "2023"].includes(`${dataEntry.time}`)));
				setMarginLeft(-15);
				setAxisFontSize(9);
				setDotLabelFontSize(9);
				setXAxisPadding(20);
				setChartHeight(250);
				break;

			case "sm":
				setChartData(data);
				setMarginLeft(-5);
				setAxisFontSize(11);
				setDotLabelFontSize(11);
				setXAxisPadding(15);
				setChartHeight(350);
				break;

			case "md":
				setChartData(data);
				setMarginLeft(-5);
				setAxisFontSize(12);
				setDotLabelFontSize(12);
				setXAxisPadding(20);
				setChartHeight(350);
				break;

			case "lg":
				setChartData(data);
				setMarginLeft(0);
				setAxisFontSize(14);
				setDotLabelFontSize(11);
				setXAxisPadding(35);
				setChartHeight(450);
				break;

			case "xl":
				setMarginLeft(0);
				setChartData(data);
				setAxisFontSize(12);
				setDotLabelFontSize(11);
				setXAxisPadding(35);
				setChartHeight(450);
				break;

			case "2xl":
			default:
				setMarginLeft(0);
				setChartData(data);
				setAxisFontSize(14);
				setDotLabelFontSize(14);
				setXAxisPadding(35);
				setChartHeight(450);
				break;
		}
	}, [chartSize, data]);

	return (
		<div className="flex flex-col gap-8">

			<LineChart
				YAxisLabel="Historical evolution of the European home appliance market"
				yAxisLabelClassName="text-lg text-gray-800 font-bold"
				data={chartData}
				height={chartHeight}
				marginLeft={marginLeft}
				labelProps={{ fontSize: dotLabelFontSize, formatter: formatNumber }}
				XAxisProps={{
					dataKey: "time",
					padding: { left: xAxisPadding, right: xAxisPadding },
					tick: { fontSize: axisFontSize },
				}}
				xDomain={[2019,2025]}
				YAxisProps={{
					tickCount: 6,
					tick: { fontSize: axisFontSize },
					tickFormatter: formatNumber,
					domain: [0, 250],
					interval: 0,
				}}
				dataKeys={EUROPEAN_MARKET_HISTORICAL_PICTURE_CHART_DATA_KEYS}
				showToolTip={false}
				chartSubtitle="In million units"
			/>
		</div>
	);
};

export { EuropeanMarketHistoricalPicture };